import { useAPI, useAuthenticatedAPI } from '../../state';
var ALL_PLAN_API = '/api/plan';
var CLIENTS_API = '/api/plan/clients';
var CLIENT_INTEGRATIONS_API = '/api/orgConfig/clients/{clientId}/integrations';
var CLIENT_INTEGRATIONS_VERIFIED_API = '/api/orgConfig/clients/{clientId}/integrations/verified';
var PLANS_API = '/api/plan';
var PLAN_API = '/api/plan/{basePlanId}';
var DUPLICATE_PLAN_API = '/api/plan/duplicate';
var VALIDATE_PLAN_API = '/api/plan/validatePlan';
var UPLOAD_DATA_API = '/api/upload';
var FORECAST_BUSINESS_UNITS_API = '/api/forecast/{integrationType}/businessUnits';
var FORECAST_LIST_API = '/api/forecast/{integrationType}/forecasts';
var FORECAST_IMPORT_API = '/api/forecast/import';
var FORECAST_ROUTING_SETS_API = '/api/forecast/{integrationType}/routingSets';
var FORECAST_GROUPS_API = '/api/forecast/{integrationType}/forecastGroups';
var FORECAST_RUNS_API = '/api/forecast/{integrationType}/forecastRuns';
var LOCK_BASELINE_API = '/api/plan/{id}/lock';
var UNLOCK_BASELINE_API = '/api/plan/{id}/unlock';
var SEAT_CAPACITY_CHECK_API = '/api/plan/{id}/seat-capacity-check';
var SEAT_CAPACITY_CHECK_ALL_API = '/api/plan/{basePlanId}/seat-capacity-check-all';
export var usePlansAPI = function () {
  return useAPI(ALL_PLAN_API);
};
export var useCreatePlanAPI = function () {
  return useAuthenticatedAPI(PLANS_API, {}, 'POST');
};
export var useDeletePlanAPI = function (basePlanId) {
  return useAuthenticatedAPI(PLAN_API, {
    basePlanId: basePlanId
  }, 'DELETE');
};
export var useLockPlanAPI = function (id) {
  return useAuthenticatedAPI(LOCK_BASELINE_API, {
    id: id
  }, 'PUT');
};
export var useUnlockPlanAPI = function (id) {
  return useAuthenticatedAPI(UNLOCK_BASELINE_API, {
    id: id
  }, 'PUT');
};
export var useSeatCapacityCheckAPI = function (id) {
  return useAuthenticatedAPI(SEAT_CAPACITY_CHECK_API, {
    id: id
  }, 'GET');
};
/** Seat-capacity check for every scenario of a base plan's family in one request. */
export var useSeatCapacityCheckAllAPI = function (basePlanId) {
  return useAuthenticatedAPI(SEAT_CAPACITY_CHECK_ALL_API, {
    basePlanId: basePlanId
  }, 'GET');
};
export var useDuplicatePlanAPI = function () {
  return useAuthenticatedAPI(DUPLICATE_PLAN_API, {}, 'POST');
};
export var useValidatePlanAPI = function () {
  return useAPI(VALIDATE_PLAN_API, {}, 'POST');
};
export var useUploadDataAPI = function () {
  return useAuthenticatedAPI(UPLOAD_DATA_API, {}, 'POST', {
    contentType: 'multipart/form-data'
  });
};
export var useForecastBusinessUnitsAPI = function (integrationType) {
  return useAPI(FORECAST_BUSINESS_UNITS_API, {
    integrationType: integrationType
  });
};
export var useForecastListAPI = function (integrationType) {
  return useAPI(FORECAST_LIST_API, {
    integrationType: integrationType
  });
};
export var useForecastImportAPI = function () {
  return useAuthenticatedAPI(FORECAST_IMPORT_API, {}, 'POST');
};
// Aspect-specific hooks (Routing Set → Forecast Groups → Forecast runs). clientId (multigeo) and the
// other query params are supplied at fetch time, mirroring the Genesys forecast hooks above.
export var useForecastRoutingSetsAPI = function (integrationType) {
  return useAPI(FORECAST_ROUTING_SETS_API, {
    integrationType: integrationType
  });
};
export var useForecastGroupsAPI = function (integrationType) {
  return useAPI(FORECAST_GROUPS_API, {
    integrationType: integrationType
  });
};
export var useForecastRunsAPI = function (integrationType) {
  return useAPI(FORECAST_RUNS_API, {
    integrationType: integrationType
  });
};
export var useClientsAPI = function () {
  return useAPI(CLIENTS_API, {}, 'GET');
};
export var useClientIntegrationsAPI = function (clientId) {
  return useAPI(CLIENT_INTEGRATIONS_API, {
    clientId: clientId
  });
};
export var useClientIntegrationsVerifiedAPI = function (clientId) {
  return useAPI(CLIENT_INTEGRATIONS_VERIFIED_API, {
    clientId: clientId
  });
};